import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";

import { ExternalLink } from "../components/ExternalLink";
import { getOktaAuth } from "../services/oktaAuth";

function oktaSite(issuerUrl: string): string {
  return issuerUrl.substring(0, issuerUrl.indexOf("/oauth2"));
}

function oktaAdminSite(siteUrl: string): string {
  return siteUrl.replace(".okta.com", "-admin.okta.com");
}

function HomePage() {
  const { clientId, issuer } = getOktaAuth().options;
  const siteUrl = oktaSite(issuer ?? "");
  const adminSiteUrl = oktaAdminSite(siteUrl);

  return (
    <Stack spacing={3}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="subtitle1" color="info.main" gutterBottom>
          When automated process gets in trouble... Tier 2 squad is here to fix
          it!
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          Useful Links
        </Typography>
        <Stack spacing={1}>
          <ExternalLink href="https://vendors.paddle.com">
            Paddle Dashboard
          </ExternalLink>
        </Stack>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Okta Configuration
        </Typography>
        <Stack spacing={1}>
          <ExternalLink href={siteUrl}>Portal</ExternalLink>
          <ExternalLink
            href={`${adminSiteUrl}/admin/app/oidc_client/instance/${clientId}`}
          >
            Tier 2 Support (this app)
          </ExternalLink>
        </Stack>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Code Repositories
        </Typography>
        <Stack spacing={1}>
          <ExternalLink href="https://github.com/pryste-sqlapi/tier2-support">
            Tier 2 Support (this app)
          </ExternalLink>
          <ExternalLink href="https://github.com/pryste-sqlapi/process-paddle-order">
            Process Paddle Order
          </ExternalLink>
          <ExternalLink href="https://github.com/pryste-sqlapi/account-services">
            Account Services
          </ExternalLink>
          <ExternalLink href="https://github.com/pryste-sqlapi/packages">
            Shared Packages
          </ExternalLink>
          <ExternalLink href="https://us-east-1.console.aws.amazon.com/codesuite/codecommit/repositories/sqlapi/browse?region=us-east-1">
            SQLAPI Site (CodeCommit)
          </ExternalLink>
          <ExternalLink href="https://us-east-1.console.aws.amazon.com/codesuite/codecommit/repositories/sqlapi-infra/browse?region=us-east-1">
            SQLAPI Infra (CodeCommit)
          </ExternalLink>
        </Stack>
      </Paper>
    </Stack>
  );
}

export { HomePage };
